<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 margin-top-3 margin-bottom-3">
            <div class="w-100 d-inline-block text-center">
              <h1 class="half-black fw-bold fw-bold filson-black-family text-uppercase text-full-32 mb-0">
                privacy policy
              </h1>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-3">
          <div class="col-12">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold text-full-24 family-filson-bold margin-bottom-3 text-size-24">
                Privacy Assurance: Safeguarding Your Information at Lush Groom
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                At Lush Groom, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </div>
            <div class="w-100 d-inline-block 
              margin-top-3">
              <h2 class="text-black fw-bold text-full-24 text-size-24 family-filson-bold margin-bottom-3">
                Information We Collect
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                We may collect personal information from you when you visit our website, register for our services, or communicate with us. This information may include your name, email address, phone number, postal address, and any other information you choose to provide.
              </p>
            </div>
            <div class="w-100 d-inline-block 
              margin-top-3">
              <h2 class="text-black fw-bold text-full-24 text-size-24 family-filson-bold margin-bottom-3">
                How We Use Your Information
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                We use the information we collect to provide and improve our services, communicate with you, process transactions, respond to your inquiries, and personalize your experience. We may also use your information to send you promotional emails or newsletters, but you can opt out of receiving these communications at any time.
              </p>
            </div>
            <div class="w-100 d-inline-block 
              margin-top-3">
              <h2 class="text-black fw-bold text-full-24 text-size-24 family-filson-bold margin-bottom-3">
                Information Sharing
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                We may share your information with third-party service providers who assist us in operating our website, conducting our business, or servicing you. These third parties are obligated to keep your information confidential and are prohibited from using your personal information for any other purpose.
              </p>
            </div>
            <div class="w-100 d-inline-block 
              margin-top-3">
              <h2 class="text-black fw-bold text-full-24 text-size-24 family-filson-bold margin-bottom-3">
                Data Security
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                We take the security of your information seriously and implement appropriate technical and organizational measures to protect it against unauthorized access, alteration, disclosure, or destruction. Children’s Privacy
                Our services are not directed to individuals under the age of 13, and we do not knowingly collect personal information from children. If you believe that we have inadvertently collected information from a child under 13, please contact us immediately so that we can take appropriate steps to remove the information.
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                  <i class="fa fa-home text-black" aria-hidden="true"></i>
                  Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'privacyBannerComponent',
  }
</script>
<style scoped></style>